module.exports = __webpack_public_path__ + "img/1.9cba4a79.png";